import React from 'react';
import { SearchBarWrapper, SearchIconWrapper, StyledInput, StyledSearchIcon } from './SearchBarStyles';

interface IProps {
  searchQuery: string;
  setSearchQueryCallback: (value: string) => void;
  placeholder: string;
}

export const SearchBar: React.FC<IProps> = (props) => {
  const { searchQuery, setSearchQueryCallback, placeholder } = props;

  return (
    <SearchBarWrapper>
      <SearchIconWrapper>
        <StyledSearchIcon className={`${searchQuery.length > 0 ? ' active' : ''}`} />
      </SearchIconWrapper>
      <StyledInput
        type='text'
        placeholder={placeholder}
        onChange={(event) => setSearchQueryCallback(event.target.value)}
        value={searchQuery}
      />
    </SearchBarWrapper>
  );
};
